/**
 * Keycloak realm role names that gate individual product features.
 * Use these constants instead of inline strings whenever a FEATURE_* role
 * name is needed, so typos are caught at reference time and refactors only
 * require a single change here.
 */
export const FeatureRole = {
  TextTranslator: 'FEATURE_TextTranslator',
  DocumentTranslator: 'FEATURE_DocumentTranslator',
  TextPolisher: 'FEATURE_TextPolisher',
  Glossary: 'FEATURE_Glossary',
  TranslationMemory: 'FEATURE_TranslationMemory',
  ResourceCreation: 'FEATURE_ResourceCreation',
  Dictionary: 'FEATURE_Dictionary',
  QualityEvaluation: 'FEATURE_QualityEvaluation',
} as const

export type FeatureRoleValue = (typeof FeatureRole)[keyof typeof FeatureRole]

/**
 * runtimeConfig.public keys that act as a second gate alongside a FeatureRole.
 * A feature is only shown when its role is present AND the corresponding flag
 * is truthy in the public runtime config.
 */
export const ConfigFlag = {
  LanguageCorrection: 'showLanguageCorrection',
  Glossaries: 'showGlossaries',
  VectorSearch: 'showVectorSearch',
  Dictionaries: 'showDictionaries',
  QualityEvaluation: 'showQualityEvaluation',
  Limits: 'showLimits',
  RetentionPolicy: 'showRetentionPolicy',
} as const

export type ConfigFlagValue = (typeof ConfigFlag)[keyof typeof ConfigFlag]
